import { BALANCE } from '../config/balance';
import type { PlayerStats } from '../core/types';
import { initSwipe } from './swipes';
import { nearestEnemy } from './target';
import { Cooldown, type WeaponController } from './weapon-controller';
import type { Engine } from './engine';

interface WhipParams {
  arcs: number;
  damage: number;
  cd: number;
  range: number;
  arc: number;
  execute: number;
}

/** 鞭：自动锁定最近敌人扇形横扫；进化处刑者，处决残血。 */
export class WhipController implements WeaponController {
  readonly id = 'whip';
  owned = false;
  private level = 0;
  private isEvolved = false;
  private cooldown = new Cooldown();

  syncBuild(level: number, evolved: boolean): void {
    this.level = level;
    this.owned = level > 0;
    this.isEvolved = evolved;
    if (!this.owned) this.cooldown.reset();
  }

  private compute(stats: PlayerStats): WhipParams {
    const w = BALANCE.weapons.whip;
    const L = this.level;
    const arcs = 1 + w.addArc.filter((lv) => L >= lv).length;
    let damage = w.dmg * (1 + w.dmgPer * (L - 1));
    const cd = (w.cd * (1 - w.cdPer * (L - 1))) / stats.attackSpeedMul;
    const range = w.range * (1 + w.rangePer * (L - 1)) * stats.areaMul;
    const arc = w.arc * (1 + w.arcPer * (L - 1));
    let execute = 0;
    if (this.isEvolved) {
      const e = BALANCE.evolutions.executioner;
      execute = e.executeRatio;
      damage *= 1 + e.dmgBonus;
    }
    return { arcs, damage, cd, range, arc, execute };
  }

  update(engine: Engine, dt: number): void {
    if (!this.owned) return;
    const p = this.compute(engine.player.stats);
    if (!this.cooldown.tick(dt, p.cd)) return;

    const player = engine.player;
    // 自动瞄准最近敌人；无敌人时朝走位方向
    const target = nearestEnemy(engine.enemyPool.all(), player.x, player.y);
    const base = target
      ? Math.atan2(target.y - player.y, target.x - player.x)
      : Math.atan2(engine.faceY, engine.faceX);
    for (let i = 0; i < p.arcs; i++) {
      const offset = (i - (p.arcs - 1) / 2) * p.arc * 0.7;
      const s = engine.swipePool.obtain();
      initSwipe(
        s,
        player.x, player.y,
        base + offset,
        p.range, p.arc, p.damage, p.execute,
      );
    }
  }
}
